(function(EF, undefined) {

  // # EF.Collections.ModulesCollection
  //
  // the ModulesCollection is responsible a just a grouping of module objects.
  //
  var ModulesCollection = Chaplin.Collection.extend({

    model: EF.Models.Module,

    modelId: function(attrs) {
      return attrs.key;
    },

    comparator: 'index',

    url: function() {
      return EF.ContentProvider.ModulesCollectionService.getModuleCollectionUrl();
    },

    // returns module by key
    getModuleByKey: function(key) {
      return this.find(function(module) {
        return module.get('key') === key;
      });
    },

    getStartingModule: function() {
      var firstNotComplete = EF.modules.findWhere(function(mod) {
        return !mod.isComplete();
      });

      if(firstNotComplete) {
        return firstNotComplete;
      }
      else {
        return false;
      }
    },

    getFirstAvailable: function(menu) {
      var firstIncomplete;
      if(menu.groups) {
        firstIncomplete = EF.groups.currentGroup().getStartingModule();
      } else {
        firstIncomplete = EF.modules.getStartingModule();
      }
      if (!firstIncomplete && EF.module){
        firstIncomplete = EF.modules.at(EF.module.get('index') + 1);
      }
      return firstIncomplete;
    },

    firstIncomplete: function() {
      return this.find(function(mod) {
        return !mod.isComplete();
      });
    },

    currentModule: function() {
      return this.firstIncomplete() || this.last();
    },

    lockModules: function(dateStatus) {
      var currentModule = this.currentModule();
      var currentModuleFound = false;
      this.each(function(mod) {
        if(!currentModuleFound) {
          currentModuleFound = mod === currentModule;
          mod.set('locked', false);
        } else {
          mod.set('locked', !mod.get('completed'));
        }
        mod.set('dateStatus', dateStatus);
      });
    },

    syncActivityAndPageProgress: function(activityProgresses) {
      this.each(function(mod) {
        var ap = activityProgresses.findWhere({ module_key: mod.get('key') });
        if(ap) {
          mod.completeAllPages();
        }
      });
    },

    completedModuleCount: function() {
      var completedModules = this.filter((mod) => !mod.get('skip_activity_progress') && mod.isComplete());
      return completedModules.length;
    },

    parse: function(response, options) {
      var modulesAttrs = [];
      let modStatuses = EF.ContentProvider.ModulesCollectionService.getModuleCollectionResponseData(response);
      _.each(this.content_modules, (mod, i)=> {
        mod = _.cloneDeep(mod);
        if(!mod.index) { mod.index = i; }
        var modStatus = EF.ContentProvider.ModulesCollectionService.getModuleCollectionModuleStatusByKey(modStatuses, mod.key);
        if(modStatus) {
          _.extend(mod, modStatus);
        }
        modulesAttrs.push(mod);
      });

      return modulesAttrs;
    }

  });

  _.extend(EF.Collections, {
    ModulesCollection: ModulesCollection
  });

})(window.EF);
